import { SidebarState } from './types';

import { INSERT_IN_QUEUE_FOR_ADD, InsertInQueueForAdd } from 'app/modules/BetSlip/actions/entries';
import { BACKUP, Backup, RESTORE, Restore } from 'app/redux/actions/persistence';

import {
  SWITCH_ACTIVE_KEY, SWITCH_TO_ALLOW_REFRESH_WARNING, SwitchActiveKey,
  SwitchToAllowRefreshWarning,
} from './actions';
import { Tab } from './constants';

// ---

const initialState: SidebarState = {
  activeTab: Tab.BET_SLIP,
  allowRefreshWarning: true,
};

type RestoreAction = Restore<Pick<SidebarState, 'allowRefreshWarning'>>;

type SidebarActions =
  | Backup
  | RestoreAction
  | InsertInQueueForAdd
  | SwitchActiveKey
  | SwitchToAllowRefreshWarning;

// ---

function handleRestore(
  state: SidebarState,
  payload: RestoreAction['payload'],
): SidebarState {
  const data = {
    allowRefreshWarning: state.allowRefreshWarning,
  };

  if ('allowRefreshWarning' in payload) {
    data.allowRefreshWarning = payload.allowRefreshWarning;
  }

  return { ...state, ...data };
}

// ---

export default function (state = initialState, action: SidebarActions): SidebarState {
  switch (action.type) {
    case BACKUP:
      return {
        allowRefreshWarning: state.allowRefreshWarning,
      } as SidebarState;

    case RESTORE:
      return handleRestore(state, action.payload);

    case SWITCH_ACTIVE_KEY:
      return {
        ...state,
        activeTab: action.payload.key,
      };

    case INSERT_IN_QUEUE_FOR_ADD:
      return {
        ...state,
        activeTab: Tab.BET_SLIP,
      };

    case SWITCH_TO_ALLOW_REFRESH_WARNING:
      return {
        ...state,
        allowRefreshWarning: action.payload.value,
      };

    default:
      return state;
  }
}
